// extracted by mini-css-extract-plugin
module.exports = {"acceptanceName":"Header_acceptanceName__2y4WN"};